import React, { ReactNode, FunctionComponent, Fragment } from 'react';
import Loader, { LoaderSize, LoaderColor, LoaderShape } from 'components/loader/loader';

type PageProps = {
    children?: ReactNode;
    isLoading?: boolean;
};

const Page: FunctionComponent<PageProps> = ({ children, isLoading }) => (
    <Fragment>
        {children}

        {isLoading ? (
            <div className="page__loader">
                <Loader
                    shape={LoaderShape.LOGO}
                    size={LoaderSize.LARGE}
                    color={LoaderColor.PRIMARY}
                />
            </div>
        ) : null}
    </Fragment>
);

export default Page;
